export enum ReturnEventType {
    PRODUCT = 'product',
    ACCESSORY = 'accessory',
}

export enum ReturnEventStatus {
    PENDING = 'pending',
    PROCESSED = 'processed',
    ERRORED = 'errored',
}

export enum AlertStatus {
    PENDING = 'PENDING',
    RESOLVED = 'RESOLVED',
}

export enum ServiceType {
    UPGRADE_ENROLLMENT = 'UPGRADE_ENROLLMENT',
    TRADE_IN = 'TRADE_IN',
    SIM = 'SIM',
}

export enum SubscriptionStatus {
    PENDING = 'PENDING',
    PENDINGPAID = 'PENDINGPAID',
    PENDINGPRESIGNED = 'PENDINGPRESIGNED',
    CANCELLED = 'CANCELLED',
    CANCELLED_BY_CLAIM = 'CANCELLED_BY_CLAIM',
    CANCELLED_BEFORE_SHIPMENT = 'CANCELLED_BEFORE_SHIPMENT',
    COMPLETED = 'COMPLETED',
    CLOSEDFINALNOTICEISSUED = 'CLOSEDFINALNOTICEISSUED',
    PRESIGNED = 'PRESIGNED',
    SIGNED = 'SIGNED',
    SHIPPED = 'SHIPPED',
    UPGRADED = 'UPGRADED',
    UPGRADEDANDRECEIVED = 'UPGRADEDANDRECEIVED',
    UPGRADEDANDRECEIVEDDAMAGED = 'UPGRADEDANDRECEIVEDDAMAGED',
    UPGRADEDANDRECEIVEDAPPROVED = 'UPGRADEDANDRECEIVEDAPPROVED',
    REMORSERETURN = 'REMORSERETURN',
    ONLYFORUPGRADE = 'ONLYFORUPGRADE',
    ONLYFORUPGRADEPAID = 'ONLYFORUPGRADEPAID',
    ONLYFORUPGRADESIGNED = 'ONLYFORUPGRADESIGNED',
    BILLINGREACTIVATED = 'BILLINGREACTIVATED',
    ARCHIVED = 'ARCHIVED',
    WRITEOFF = 'WRITEOFF',
    BUYOUT = 'BUYOUT',
    LOSTINTRANSIT = 'LOSTINTRANSIT',
}

export enum SubscriptionOrderType {
    ENROLLMENT = 'ENROLLMENT',
    UPGRADE = 'UPGRADE',
}

export enum SubscriptionFeeStatus {
    ACTIVE = 'ACTIVE',
    REFUNDED = 'REFUNDED',
    CANCELLEDBEFOREINVOICE = 'CANCELLEDBEFOREINVOICE',
    EXPECTED = 'EXPECTED',
}

export enum SubscriptionFeePeriodType {
    ONCE = 'ONCE',
    MONTHLY = 'MONTHLY',
}

export enum SubscriptionFeeType {
    DISCOUNT = 'DISCOUNT',
    TRADEIN = 'TRADEIN',
    PRODUCT = 'PRODUCT',
    ACCESSORY = 'ACCESSORY',
    CUSTOM = 'CUSTOM',
    REVERSAL = 'REVERSAL',
    ADDONDISCOUNT = 'ADDONDISCOUNT',
    ADDONPRODUCT = 'ADDONPRODUCT',
}

export enum SubscriptionPaymentType {
    /** @deprecated Use {@link UPFRONT_PAYMENT} instead */
    FIRST_MONTH_PAYMENT = 'first-month-payment',
    UPFRONT_PAYMENT = 'upfront-payment',
}

export enum SubscriptionPaymentStatus {
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED',
    PAID = 'PAID',
    REFUNDED = 'REFUNDED',
}

export enum SubscriptionInvoicePaymentType {
    RECURRING_PAYMENT = 'RECURRING-PAYMENT',
    UNSCHEDULED_PAYMENT = 'UNSCHEDULED-PAYMENT',
    ADMIN_PAYMENT = 'ADMIN_PAYMENT',
}

export enum SubscriptionInvoicePaymentStatus {
    PENDING = 'PENDING',
    PAID = 'PAID',
    FAILED = 'FAILED',
}

export enum SubscriptionInvoicePaymentCaptureStatus {
    INITIALIZED = 'INITIALIZED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}

export enum PlanCode {
    FLEX = 'FLEX',
    VALUE = 'VALUE',
}

export enum PlanCodeLowercase {
    FLEX = 'flex',
    VALUE = 'value',
}

export enum TradeInPotStatus {
    ACTIVE = 'ACTIVE',
    INFORMATIVE = 'INFORMATIVE',
}

export enum ClaimStatus {
    PENDING = 'pending',
    WAITINGFORPAYMENT = 'waiting-for-payment',
    PAYMENTRECEIVED = 'payment-received',
    PAYMENTERROR = 'payment-error',
    APPROVED = 'approved',
    RETURNKITSENT = 'return-kit-sent',
    DEVICERECEIVED = 'device-received',
    DEVICERECEIVEDAPPROVED = 'device-received-approved',
    DEVICERECEIVEDDAMAGED = 'device-received-damaged',
    DEVICENOTRECEIVED = 'device-not-received',
    BILLINGREACTIVATED = 'billing-reactivated',
    // final statuses
    DECLINED = 'declined',
    COMPLETED = 'completed',
    LOSTINTRANSIT = 'lost-in-transit',
    // Automated cancel claim statuses
    SENDRETURNKIT = 'send-return-kit',
    HANDLEDBYUPGRADE = 'handled-by-upgrade',
}

export const ActiveSubscriptionClaimStatuses = [
    ClaimStatus.PENDING,
    ClaimStatus.SENDRETURNKIT,
    ClaimStatus.WAITINGFORPAYMENT,
    ClaimStatus.PAYMENTRECEIVED,
    ClaimStatus.PAYMENTERROR,
    ClaimStatus.APPROVED,
    ClaimStatus.RETURNKITSENT,
    ClaimStatus.DEVICERECEIVED,
    ClaimStatus.DEVICERECEIVEDDAMAGED,
]
export const EndedSubscriptionClaimStatuses = [
    ClaimStatus.DECLINED,
    ClaimStatus.COMPLETED,
    ClaimStatus.HANDLEDBYUPGRADE,
    ClaimStatus.LOSTINTRANSIT,
]

export enum ClaimType {
    CANCEL = 0,
    SWAP = 1,
    AUTOMATED_CANCEL = 2,
    SWAP_BOLTTECH = 3,
    REPAIR_BOLTTECH = 4,
    END_OF_LEASE_BOLTTECH = 5,
    UNKNOWN_BOLTTECH = 6,
}

export enum ClaimDamageType {
    FELLANDBROKE = 'fell-and-broke',
    STOPPEDWORKING = 'stopped-working',
    LOSTORSTOLEN = 'lost',
}

export enum ClaimProductResolution {
    RETURN = 'return',
    KEEP = 'keep',
    UPGRADE = 'upgrade',
}

export enum ClaimDamageLocation {
    FRONTSIDE = 'front-side',
    BACKSIDE = 'back-side',
    CAMERA = 'camera',
    AUDIO = 'audio',
    NETWORK = 'network',
    POWER = 'on-off-problem',
    OTHER = 'other',
}

export const ActiveSubscriptionStatuses = [
    SubscriptionStatus.COMPLETED,
    SubscriptionStatus.SHIPPED,
    SubscriptionStatus.SIGNED,
    SubscriptionStatus.ONLYFORUPGRADESIGNED,
]
export const EndedSubscriptionStatuses = [
    SubscriptionStatus.CLOSEDFINALNOTICEISSUED,
    SubscriptionStatus.UPGRADED,
    SubscriptionStatus.UPGRADEDANDRECEIVED,
    SubscriptionStatus.REMORSERETURN,
    SubscriptionStatus.BUYOUT,
    SubscriptionStatus.LOSTINTRANSIT,
    SubscriptionStatus.CANCELLED,
    SubscriptionStatus.CANCELLED_BY_CLAIM,
    SubscriptionStatus.CANCELLED_BEFORE_SHIPMENT,
]
export const ActiveBillingSubscriptionStatuses = [SubscriptionStatus.COMPLETED, SubscriptionStatus.BILLINGREACTIVATED]

export enum SubscriptionInvoiceRegistrationStatus {
    PENDING = 'PENDING',
    REGISTERED = 'REGISTERED',
    FAILED = 'FAILED',
}

export enum CreditCheckStatus {
    PENDING = 'PENDING',
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED',
    ONLYFORUPGRADE = 'ONLYFORUPGRADE',
}

export enum PolicyProvider {
    INZMO = 'INZMO',
    BOLTTECH = 'BOLTTECH',
}

export enum InzmoPolicyStatus {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
}

export enum BolttechPolicyStatus {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
}

export enum AdminUserRole {
    USER = 'USER',
    ADMIN = 'ADMIN',
    SUPERADMIN = 'SUPERADMIN',
    TOKEN = 'TOKEN',
}

export enum AdminUserStatus {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED',
}

export enum CustomerPersonNumberStatus {
    WHITELISTED = 'WHITELISTED',
    BLACKLISTED = 'BLACKLISTED',
}

export enum CustomerStatus {
    ACTIVE = 'ACTIVE',
    FRAUDULENT = 'FRAUDULENT',
    PAYINGISSUES = 'PAYINGISSUES',
    DUPLICATE = 'DUPLICATE',
}

// Payex

export enum PayexPaymentOrderStatus {
    INITIALIZED = 'Initialized',
    PAID = 'Paid',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled',
    ABORTED = 'Aborted',
}

export enum PayexTransactionState {
    INITIALIZED = 'Initialized',
    COMPLETED = 'Completed',
    FAILED = 'Failed',
}

export enum PayexPaymentAction {
    CANCEL = 'cancel',
    COMPLETE = 'complete',
    CALLBACK = 'callback',
}

export enum PayexCaptureItemType {
    PRODUCT = 'PRODUCT',
    SERVICE = 'SERVICE',
    SHIPPING_FEE = 'SHIPPING_FEE',
    PAYMENT_FEE = 'PAYMENT_FEE',
    DISCOUNT = 'DISCOUNT',
    VALUE_CODE = 'VALUE_CODE',
    OTHER = 'OTHER',
}

export enum PayexTokenType {
    UNSCHEDULED = 'unscheduled',
}

export enum PayexOperationType {
    PURCHASE = 'Purchase',
    UNSCHEDULED_PURCHASE = 'UnscheduledPurchase',
    VERIFY = 'Verify',
}

// LisaAnd

export enum LisaAndLeaseDurationType {
    MONTHS = 'MONTHS',
    DAYS = 'DAYS',
    QUARTER = 'QUARTER',
}

export enum LisaAndAgreementType {
    FIXED = 'FIXED',
    FLEXIBLE = 'FLEXIBLE',
}

export enum LisaAndSubsidyType {
    TRADE_IN = 'TRADE_IN',
}

export enum LisaAndPaymentSuffix {
    PAYMENT_METHOD_UPDATE = 'P',
    MANUAL_SUBSCRIPTION_FEE = 'M',
    SUBSCRIPTION_FEE = 'S',
    SUBSCRIPTION_FEE_REFUND = 'SR',
    DEPOSIT_PAYMENT = 'D',
    DEPOSIT_REFUND = 'DR',
    ACCESSORY_REFUND = 'AR',
    SWAP_SERVICE = 'X',
    SWAP_SERVICE_REFUND = 'XR',
}

export enum LisaAndValidationStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    COOL_DOWN = 'COOL_DOWN',
}

export enum LisaAndValidationReason {
    CUSTOMER_FAILED_CREDIT_FRAMEWORK = 'CUSTOMER_FAILED_CREDIT_FRAMEWORK',
    INCONCLUSIVE_CREDIT_RESULT = 'INCONCLUSIVE_CREDIT_RESULT',
    NONE = '',
}

export enum LisaAndValidationRecommendation {
    YES = 'YES',
    NO = 'NO',
}

export enum LisaAndRentalAgreementType {
    FIXED = 'FIXED',
    FLEXIBLE = 'FLEXIBLE',
}

export enum LisaAndRentalAgreementStatus {
    INITIATED = 'INITIATED',
    SIGNED = 'SIGNED',
    FAILED = 'FAILED',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    INACTIVE = 'INACTIVE',
    ARCHIVED = 'ARCHIVED',
}

export enum LisaAndRentalAgreementCancelReason {
    UPGRADE = 'UPGRADE',
    CANCELLATION = 'CANCELLATION',
    CANCELLED_BY_CLAIM = 'CANCELLED_BY_CLAIM',
    CANCELLED_BEFORE_SHIPMENT = 'CANCELLED_BEFORE_SHIPMENT',
    REMORSE_RETURN = 'REMORSE_RETURN', // TODO currently does not exist in the API
}

export enum SupportedCountryCodes {
    SWEDEN = 'SE',
    FINLAND = 'FI',
    NORWAY = 'NO',
    DENMARK = 'DK',
}

export enum SupportedCountryCodesAlpha3 {
    SWEDEN = 'SWE',
    FINLAND = 'FIN',
    NORWAY = 'NOR',
    DENMARK = 'DNK',
}

export enum SupportedEmailTemplates {
    'END_OF_PERIOD_DEVICE_NOT_RECEIVED_EMAIL_{{COUNTRY}}' = 'END_OF_PERIOD_DEVICE_NOT_RECEIVED_EMAIL_{{COUNTRY}}',
    'END_OF_PERIOD_DEVICE_RECEIVED_APPROVED_EMAIL_{{COUNTRY}}' = 'END_OF_PERIOD_DEVICE_RECEIVED_APPROVED_EMAIL_{{COUNTRY}}',
    'END_OF_PERIOD_DEVICE_RECEIVED_DAMAGED_EMAIL_{{COUNTRY}}' = 'END_OF_PERIOD_DEVICE_RECEIVED_DAMAGED_EMAIL_{{COUNTRY}}',
    'END_OF_PERIOD_DEVICE_RECEIVED_EMAIL_{{COUNTRY}}' = 'END_OF_PERIOD_DEVICE_RECEIVED_EMAIL_{{COUNTRY}}',
    'END_OF_PERIOD_RETURN_KIT_SENT_EMAIL_{{COUNTRY}}' = 'END_OF_PERIOD_RETURN_KIT_SENT_EMAIL_{{COUNTRY}}',
    'GREETINGS_EMAIL_{{PLAN}}_{{COUNTRY}}' = 'GREETINGS_EMAIL_{{PLAN}}_{{COUNTRY}}',
    'GREETINGS_UPGRADERS_EMAIL_{{PLAN}}_{{COUNTRY}}' = 'GREETINGS_UPGRADERS_EMAIL_{{PLAN}}_{{COUNTRY}}',
    'FIRST_MONTH_PAYMENT_RECEIVED_EMAIL_{{PLAN}}_{{COUNTRY}}' = 'FIRST_MONTH_PAYMENT_RECEIVED_EMAIL_{{PLAN}}_{{COUNTRY}}',
    'UPGRADE_EMAIL_{{PLAN}}_{{COUNTRY}}' = 'UPGRADE_EMAIL_{{PLAN}}_{{COUNTRY}}',
    'UPGRADE_CREATED_CAREPLUS_FLEX_EMAIL_{{COUNTRY}}' = 'UPGRADE_CREATED_CAREPLUS_FLEX_EMAIL_{{COUNTRY}}',
    'UPGRADE_CREATED_CAREPLUS_VALUE_EMAIL_{{COUNTRY}}' = 'UPGRADE_CREATED_CAREPLUS_VALUE_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_CREATED_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_CREATED_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_APPROVED_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_APPROVED_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_DECLINED_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_DECLINED_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_NEW_DEVICE_SENT_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_NEW_DEVICE_SENT_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_RETURN_KIT_NOT_RECEIVED_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_RETURN_KIT_NOT_RECEIVED_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_RETURN_KIT_RECEIVED_EMAIL_{{COUNTRY}}' = 'SWAP_CLAIM_RETURN_KIT_RECEIVED_EMAIL_{{COUNTRY}}',
    'CANCEL_CLAIM_CREATED_EMAIL_{{COUNTRY}}' = 'CANCEL_CLAIM_CREATED_EMAIL_{{COUNTRY}}',
    'CANCEL_CLAIM_CREATED_CAREPLUS_FLEX_EMAIL_{{COUNTRY}}' = 'CANCEL_CLAIM_CREATED_CAREPLUS_FLEX_EMAIL_{{COUNTRY}}',
    'CANCEL_CLAIM_CREATED_CAREPLUS_VALUE_EMAIL_{{COUNTRY}}' = 'CANCEL_CLAIM_CREATED_CAREPLUS_VALUE_EMAIL_{{COUNTRY}}',
    'VALUE_CANCELLATION_{{COUNTRY}}' = 'VALUE_CANCELLATION_{{COUNTRY}}',
    'FLEX_CANCELLATION_{{COUNTRY}}' = 'FLEX_CANCELLATION_{{COUNTRY}}',
    'FLEX_CANCELLATION_CAREPLUS_{{COUNTRY}}' = 'FLEX_CANCELLATION_CAREPLUS_{{COUNTRY}}',
    'CANCELLATION_DEVICE_RECEIVED_VALUE_{{COUNTRY}}' = 'CANCELLATION_DEVICE_RECEIVED_VALUE_{{COUNTRY}}',
    'CANCELLATION_DEVICE_RECEIVED_FLEX_{{COUNTRY}}' = 'CANCELLATION_DEVICE_RECEIVED_FLEX_{{COUNTRY}}',
    'CANCELLATION_DEVICE_MISSING_VALUE_{{COUNTRY}}' = 'CANCELLATION_DEVICE_MISSING_VALUE_{{COUNTRY}}',
    'CANCELLATION_DEVICE_MISSING_FLEX_{{COUNTRY}}' = 'CANCELLATION_DEVICE_MISSING_FLEX_{{COUNTRY}}',

    'CANCEL_BILLING_REACTIVATED_EMAIL_{{COUNTRY}}' = 'CANCEL_BILLING_REACTIVATED_EMAIL_{{COUNTRY}}',
    'DEVICE_RECEIVED_EMAIL_{{COUNTRY}}' = 'DEVICE_RECEIVED_EMAIL_{{COUNTRY}}',
    'DEVICE_RECEIVED_APPROVED_EMAIL_{{COUNTRY}}' = 'DEVICE_RECEIVED_APPROVED_EMAIL_{{COUNTRY}}',
    'DEVICE_RECEIVED_DAMAGED_EMAIL_{{COUNTRY}}' = 'DEVICE_RECEIVED_DAMAGED_EMAIL_{{COUNTRY}}',
    'SWAP_CLAIM_PAYMENT_RECEIVED_{{COUNTRY}}' = 'SWAP_CLAIM_PAYMENT_RECEIVED_{{COUNTRY}}',
    'SWAP_CLAIM_PAYMENT_ERROR_{{COUNTRY}}' = 'SWAP_CLAIM_PAYMENT_ERROR_{{COUNTRY}}',
    'AUTOMATIC_PAYMENT_FIRST_ERROR_{{COUNTRY}}' = 'AUTOMATIC_PAYMENT_FIRST_ERROR_{{COUNTRY}}',
    'AUTOMATIC_PAYMENT_SECOND_ERROR_{{COUNTRY}}' = 'AUTOMATIC_PAYMENT_SECOND_ERROR_{{COUNTRY}}',
    'AUTOMATIC_PAYMENT_THIRD_ERROR_{{COUNTRY}}' = 'AUTOMATIC_PAYMENT_THIRD_ERROR_{{COUNTRY}}',
    'AUTOMATIC_PAYMENT_FOURTH_ERROR_{{COUNTRY}}' = 'AUTOMATIC_PAYMENT_FOURTH_ERROR_{{COUNTRY}}',
    'AUTOMATIC_PAYMENT_SUCCESS_{{COUNTRY}}' = 'AUTOMATIC_PAYMENT_SUCCESS_{{COUNTRY}}',
    'UPDATE_PAYMENT_DETAILS_{{COUNTRY}}' = 'UPDATE_PAYMENT_DETAILS_{{COUNTRY}}',
    'PAYMENT_ISSUE_NOV_DEC_{{COUNTRY}}' = 'PAYMENT_ISSUE_NOV_DEC_{{COUNTRY}}',
    'FULL_FLEX_UPGRADE_{{COUNTRY}}' = 'FULL_FLEX_UPGRADE_{{COUNTRY}}',

    'GREETINGS_EMAIL_60_DAYS_AFTER_VALUE_{{COUNTRY}}' = 'GREETINGS_EMAIL_60_DAYS_AFTER_VALUE_{{COUNTRY}}',
    'GREETINGS_EMAIL_60_DAYS_AFTER_FLEX_{{COUNTRY}}' = 'GREETINGS_EMAIL_60_DAYS_AFTER_FLEX_{{COUNTRY}}',

    'VALUE_UPGRADE_45_DAYS_LEFT_{{COUNTRY}}' = 'VALUE_UPGRADE_45_DAYS_LEFT_{{COUNTRY}}',
    'VALUE_UPGRADE_30_DAYS_LEFT_{{COUNTRY}}' = 'VALUE_UPGRADE_30_DAYS_LEFT_{{COUNTRY}}',
    'VALUE_UPGRADE_15_DAYS_LEFT_{{COUNTRY}}' = 'VALUE_UPGRADE_15_DAYS_LEFT_{{COUNTRY}}',
    'VALUE_UPGRADE_7_DAYS_LEFT_{{COUNTRY}}' = 'VALUE_UPGRADE_7_DAYS_LEFT_{{COUNTRY}}',
    'VALUE_UPGRADE_1_DAY_AFTER_{{COUNTRY}}' = 'VALUE_UPGRADE_1_DAY_AFTER_{{COUNTRY}}',
    'VALUE_UPGRADE_7_DAYS_AFTER_{{COUNTRY}}' = 'VALUE_UPGRADE_7_DAYS_AFTER_{{COUNTRY}}',

    // Admin authentication
    'ADMIN_TFA_LINK' = 'ADMIN_TFA_LINK',
}

export enum ProductType {
    MOBILEPHONE = 'mobilephone',
    TABLET = 'tablet',
    SMARTWATCH = 'smartwatch',
    LAPTOP = 'laptop',
}

export enum ProductManufacturer {
    SAMSUNG = 'SAMSUNG',
}

export enum RentalProductType {
    PHONE = 'PHONE',
    LAPTOP = 'LAPTOP',
    TABLET = 'TABLET',
    SMARTWATCH = 'SMARTWATCH',
    OTHER = 'OTHER',
}

export enum SubscriptionInvoiceStatus {
    PENDING = 'pending',
    ACTIVE = 'active',
    PAID = 'paid',
    CANCELLED = 'cancelled',
    REFUNDED = 'refunded',
    /**
     * Expected invoices are pre-generated invoices that will be created in the future.
     * They are used for forecasting and can be easily deleted without impacting actual billing.
     * VALUE subscriptions get expected invoices until their planned end.
     * FLEX subscriptions get 12 months of expected invoices.
     */
    EXPECTED = 'expected',
}

export enum SubscriptionInvoiceType {
    DEBIT = 'debit',
    CREDIT = 'credit',
}

export enum SubscriptionPaymentLineStatus {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    PAID = 'PAID',
    REFUNDED = 'REFUNDED',
}

export enum SubscriptionPaymentLineType {
    /** @deprecated Use {@link UPFRONT_PAYMENT_PRODUCT} instead */
    FIRST_MONTH_PRODUCT = 'FIRST_MONTH_PRODUCT',
    /** @deprecated Use {@link UPFRONT_PAYMENT_PRODUCT_DISCOUNT} instead */
    FIRST_MONTH_PRODUCT_DISCOUNT = 'FIRST_MONTH_PRODUCT_DISCOUNT',
    /** @deprecated Use {@link UPFRONT_PAYMENT_TRADE_IN_DISCOUNT} instead */
    FIRST_MONTH_TRADE_IN_DISCOUNT = 'FIRST_MONTH_TRADE_IN_DISCOUNT',
    /** @deprecated Use {@link UPFRONT_PAYMENT_ACCESSORIES} instead */
    FIRST_MONTH_ACCESSORIES = 'FIRST_MONTH_ACCESSORIES',

    UPFRONT_PAYMENT_PRODUCT = 'UPFRONT_PAYMENT_PRODUCT',
    UPFRONT_PAYMENT_PRODUCT_DISCOUNT = 'UPFRONT_PAYMENT_PRODUCT_DISCOUNT',
    UPFRONT_PAYMENT_TRADE_IN_DISCOUNT = 'UPFRONT_PAYMENT_TRADE_IN_DISCOUNT',
    UPFRONT_PAYMENT_ACCESSORIES = 'UPFRONT_PAYMENT_ACCESSORIES',
}

export enum TradeInPotLineType {
    TRADE_IN = 'TRADE_IN',
    TRADE_IN_READJUSTMENT = 'TRADE_IN_READJUSTMENT',
    USED_ON_INVOICE = 'USED_ON_INVOICE',
    MANUAL_TRANSACTION = 'MANUAL_TRANSACTION',
    REIMBURSEMENT = 'REIMBURSEMENT',
}

export enum InvoicingSystem {
    PENDING = 'PENDING',
    INTERNAL = 'INTERNAL',
    SVEA = 'SVEA',
    LISAAND = 'LISAAND',
}

export enum VendorNotificationStatus {
    MISSING = 'MISSING',
    REQUESTED = 'REQUESTED',
    SENT = 'SENT',
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED',
    ERRORED = 'ERRORED',
}

export enum TradeInServiceNames {
    FOXWAY_TRADE_IN = 'T-FOXWAY-TRADEIN',
    TRADE_IN = 'TRADE_IN',
}

// currently we create invoices on the 5th of each month
export const INVOICE_CREATION_DAY = 5

export enum ScriveAuthenticationProvider {
    /* A Finnish online banking service. */
    FITUPAS = 'fiTupas',
    /* SEBANKID is a Swedish BankID. */
    SEBANKID = 'seBankID',
    /* A Norwegian BankID. */
    NOBANKID = 'noBankID',
    /* A Danish BankID. */
    DKMITID = 'dkMitID',
}

export enum MessageStatus {
    PENDING = 'pending',
    PROCESSED = 'processed',
    FAILED = 'failed',
    NOTFOUND = 'notfound',
    FOUNDBUTIGNORED = 'foundbutignored',
}

export enum ProductStatus {
    ACTIVE = 'active',
    ARCHIVED = 'archived',
}
